import React, { Component } from "react";

// Views
import Header from "../component/header";
// import Sidebar from "../component/sidebar";
import Sidebar from "../component/sidebar/sidebarv2"
import Navbar from "../component/navbar";
import Footer from "../component/footer";
import { Switch, Route, Redirect } from "react-router-dom";

// Route
import routes from "../routes";

class AdminLayout extends Component {
  constructor(props) {
    super(props);
    this.state = {
      _notificationSystem: null,
      color: "",
      hasImage: false,
      menuList: [],
      fixedClasses: "dropdown show-dropdown open",
    };
  }

  getBrandText = (path) => {
    for (let i = 0; i < routes.length; i++) {
      if (
        this.props.location.pathname.indexOf(
          routes[i].layout + routes[i].path
        ) !== -1
      ) {
        return routes[i].name;
      }
    }
    return "Dashboard";
  };

  validateRoles = (id) => {
    let token = window.localStorage.getItem("is_token");
    let user = window.localStorage.getItem("is_user");
    if (!token || !user) return false;

    return true;
  };
  getRoutes = (routes) => {
    return routes.map((prop, key) => {
      if (prop.layout === "/admin") {
        return (
          <Route
            exact
            path={prop.layout + prop.path}
            render={(props) =>
              this.validateRoles() ? (
                <prop.component {...props} />
              ) : (
                <Redirect to="/login?unauthorize" />
              )
            }
            key={key}
          />
        );
      } else {
        return null;
      }
    });
  };

  render() {
    return (
      <div className="wrapper">
        <Header />
        <Sidebar />
        <div className="content-wrapper">
          <Navbar
            {...this.props}
            brandText={this.getBrandText(this.props.location.pathname)}
          />
          <Switch>{this.getRoutes(routes)}</Switch>
        </div>
        <Footer />
      </div>
    );
  }
}

export default AdminLayout;
